// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfo_a"};